import { Link } from '@tanstack/react-router';
import type { RecordFieldValue } from '../../lib/api-types';
import { MarkdownViewer } from '../content/MarkdownContent';
import { FieldLink, fieldWebURL } from './FieldLink';
import styles from './Crm.module.css';

export function FieldValue({ field }: { field: RecordFieldValue }) {
  if (field.type !== 'relation' && fieldWebURL(field.displayValue)) {
    return <FieldLink value={field.displayValue} />;
  }
  if (field.type === 'markdown') {
    return <MarkdownViewer source={String(field.value ?? field.displayValue ?? '')} />;
  }

  if (field.type === 'relation') {
    if (field.relationReferences.length === 0) return <span className={styles.fieldEmpty}>—</span>;
    return (
      <span className={styles.chips}>
        {field.relationReferences.map((reference) => (
          <Link
            key={reference.id}
            to="/app/o/$object/$recordId"
            params={{ object: reference.objectNamePlural, recordId: reference.id }}
            className={styles.chip}
          >
            {reference.label}
          </Link>
        ))}
      </span>
    );
  }

  if (!field.displayValue) return <span className={styles.fieldEmpty}>—</span>;

  if (field.type === 'emails') {
    return <a href={`mailto:${field.displayValue}`}>{field.displayValue}</a>;
  }
  if (field.type === 'phones') {
    return <a href={`tel:${field.displayValue}`}>{field.displayValue}</a>;
  }
  if (field.type === 'date' || field.type === 'datetime') {
    const parsed = new Date(field.displayValue);
    if (!Number.isNaN(parsed.getTime())) {
      return (
        <time dateTime={parsed.toISOString()}>
          {parsed.toLocaleString(undefined, {
            dateStyle: 'medium',
            ...(field.type === 'datetime' ? { timeStyle: 'short' } : {}),
          })}
        </time>
      );
    }
  }

  return <>{field.displayValue}</>;
}

